import React from "react";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import TextAreaField from "../../../components/form/TextAreaField";
import SingleFileUpload from "../../../components/form/SingleFileUpload";
import { addProvincialReqApprove } from "../../../features/projectsSlice";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/form/InputField";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { addProvincialApproveSchema } from "../../../schemas";

const AddProvincialApproval = ({ id, name }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const loading = useSelector(
    (state) => state.projects.load.addProvincialReqApprove
  );

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(addProvincialApproveSchema) });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(addProvincialReqApprove(data));
      if (addProvincialReqApprove.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification("Project approved successfully!", "success");
        return navigate("/requests/provincial-approvals");
      } else {
        addNotification(res.payload.message, "error");
        if (res.payload.code === 412) {
          dispatch(closeModal());
          navigate("/requests/provincial-approvals");
        }
      }
    } catch (error) {
      addNotification(error.message, "error");
    }
  };

  return (
    <>
      {id && (
        <div className="min-w-80 sm:min-w-96 max-w-2xl w-full">
          <div className="flex flex-col justify-center items-center gap-2 py-5 border-b border-bkg2 mb-4 text-text-1/80">
            <h4>Approve Application</h4>
          </div>
          <p className="font-extrabold text-text-1/80">{name}</p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            method="post"
            encType="multipart/form-data"
          >
            <TextAreaField
              register={register}
              label="Comment"
              name="comment"
              errors={errors.comment}
            />
            <SingleFileUpload
              register={register}
              setValue={setValue}
              label="Council Minutes"
              name="provincial_council_minute"
              errors={errors.provincial_council_minute}
              accept="application/pdf"
            />
            <InputField
              register={register}
              name="id"
              defaultValue={id}
              type="hidden"
            />
            <ResourseButtons loading={loading} />
          </form>
        </div>
      )}
    </>
  );
};

export default AddProvincialApproval;
